export const base_url = "https://api.bharatdarshan.app/";
//! login
export const admin_login = "api/admin/login"

//! Dashboard
export const get_dashboard = 'api/admin/countForDashboard'

//! User
export const get_user = "api/admin/getAllUsers";
export const create_user = "api/admin/addUser"; // -- Not Working
export const update_user = "api/admin/updateUser"; // -- Not Working
export const delete_user = "api/admin/deleteUser";
export const change_user_status = "api/admin/changeUserStatus";

//! Sub Admin
export const get_sub_admin = "api/admin/getAllSubadmins";
export const create_sub_admin = "api/admin/addSubadmin";
export const update_sub_admin = "api/admin/updateSubadmin";
export const delete_sub_admin = "api/admin/deleteSubadmin";
export const change_sub_admin_status = "api/admin/changeSubAdminStatus";

//! Astro-Mall
export const get_astro_mall_category = 'api/e-commerce/get_product_category';
export const create_astro_mall_category = 'api/e-commerce/create_product_category';
export const update_astro_mall_category = 'api/e-commerce/update_product_category';
export const delete_astro_mall_category = 'api/e-commerce/delete_product_category';

export const get_astro_mall_product = 'api/e-commerce/get_all_products';
export const create_astro_mall_product = 'api/e-commerce/create_products';
export const update_astro_mall_product = 'api/e-commerce/update_products';
export const delete_astro_mall_product = 'api/e-commerce/delete_product';

//* Order History
export const get_order_history = 'api/e-commerce/order_history';
export const change_order_status = 'api/e-commerce/change_order_status';


//! Astro-Puja
export const get_puja = 'api/e-commerce/get_puja';
export const create_puja = 'api/e-commerce/create_puja';
export const update_puja = 'api/e-commerce/update_puja';
export const delete_puja = 'api/e-commerce/delete_puja';
export const get_puja_request = 'api/e-commerce/all_requested_puja';
export const assign_puja = 'api/e-commerce/puja_assign_to_astrologer';
export const change_puja_status = 'api/e-commerce/change_puja_status';
export const get_puja_booked = 'api/e-commerce/get_customer_booked_pooja';
export const get_puja_history = 'api/e-commerce/get_puja_history';

//! History
export const get_chat_history = 'api/admin/get_chat_history';
export const get_call_history = 'api/admin/get_call_history';
export const get_video_call_history = 'api/admin/all_videocall_history';
export const get_live_history = 'api/admin/all_live_videocall_history';
export const get_gift_history = 'api/admin/get_all_gift_history';
export const get_service_history = 'api/admin/getRechargeHistory';

//! Skill
export const get_skill = 'api/admin/get-skill';
export const create_skill = 'api/admin/skill';
export const update_skill = 'api/admin/update-skill';
export const delete_skill = 'api/admin/delete-skill';

//! Remedies
export const get_remedies = 'api/admin/view-remedy';
export const create_remedies = 'api/admin/add-remedy';
export const update_remedies = 'api/admin/update-remedy';
export const delete_remedies = 'api/admin/delete-remedy';

//! Expertise 
export const get_expertise = 'api/admin/get-all-expertise';
export const create_expertise = 'api/admin/add-expertise';
export const update_expertise = 'api/admin/update-expertise';
export const delete_expertise = 'api/admin/delete-expertise';
export const get_main_expertise = 'api/admin/get-all-main-expertise';
export const create_main_expertise = 'api/admin/add-main-expertise';
export const update_main_expertise = 'api/admin/update-main-expertise';
export const delete_main_expertise = 'api/admin/delete-main-expertise';

//! Language
export const get_language = 'api/admin/get_language';
export const create_language = 'api/admin/create_language';
export const update_language = 'api/admin/update_language';
export const delete_language = 'api/admin/delete_language';

//! Banner
export const get_banner = "api/admin/getBanners";
export const create_banner = "api/admin/addBanner";
export const update_banner = "api/admin/updateBanner";
export const delete_banner = "api/admin/deleteBannerById";
export const change_banner_status = "api/admin/changeBannerStatus";

//! Category
export const get_category = "api/admin/getCategories";
export const create_category = "api/admin/createCategory";
export const update_category = "api/admin/updateCategory";
export const delete_category = "api/admin/deleteCategory";
export const change_category_status = "api/admin/changeCategoryStatus";

//! Sub-Category
export const get_sub_category = "api/admin/getSubCategories";
export const create_sub_category = "api/admin/createSubCategory";
export const update_sub_category = "api/admin/updateSubCategory";
export const delete_sub_category = "api/admin/deleteSubCategory";
export const change_sub_category_status = "api/admin/changeSubCategoryStatus";
export const get_sub_category_by_category_id = "api/admin/getSubCategoryByCategoryId";

//! Yatra
export const get_yatra = "api/admin/getYatra";
export const create_yatra = "api/admin/createYatra";
export const update_yatra = "api/admin/updateYatra";
export const delete_yatra = "api/admin/deleteYatra";
export const change_yatra_status = "api/admin/changeYatraStatus";

export const get_yatra_history = 'api/admin/getYatraHistory';

//! Podcast
export const get_podcast = "api/admin/getAudio";
export const create_podcast = "api/admin/createAudio";
export const update_podcast = "api/admin/updateAudio";
export const delete_podcast = "api/admin/deleteAudio";
export const change_podcast_status = "api/admin/changeAudioStatus";

//! Video-Clip
export const get_videoclip = "api/admin/getVideo";
export const create_videoclip = "api/admin/createVideo";
export const update_videoclip = "api/admin/updateVideo";
export const delete_videoclip = "api/admin/deleteVideo";
export const change_videoclip_status = "api/admin/changeVideoStatus";

//! News
export const get_news = "api/admin/getNews";
export const create_news = "api/admin/createNews";
export const update_news = "api/admin/updateNews";
export const delete_news = "api/admin/deleteNews";
export const change_news_status = "api/admin/changeNewsStatus";

//! Sanchar
//? live
export const get_live = "api/admin/getLive";
export const create_live = "api/admin/addLive";
export const update_live = (id) => `api/admin/updateLive/${id}`;
export const delete_live = (id) => `api/admin/deleteLive/${id}`;
export const change_live_status = "api/admin/changeLiveStatus";

//! Religious
//? Daily Darshan
export const get_daily_darshan = "api/admin/getDailyDarshan";
export const create_daily_darshan = "api/admin/addDailyDarshan";
export const update_daily_darshan = 'api/admin/updateDailyDarshan';
export const delete_daily_darshan = 'api/admin/deleteDailyDarshan';
export const change_daily_darshan_status = "api/admin/changeDailyDarshanStatus";

//! Ecommerce
export const get_ecommerce_category = "api/product/getProductCategories";
export const create_ecommerce_category = "api/product/createProductCategory";
export const update_ecommerce_category = "api/product/updateProductCategory";
export const delete_ecommerce_category = "api/product/deleteProductCategory";
export const change_ecommerce_category_status = "api/product/changeProductCategoryStatus";

export const get_ecommerce_sub_category_by_category_id = "api/product/getProductSubCategoriesByCategoryId";

export const get_ecommerce_sub_category = "api/product/getProductSubCategories";
export const create_ecommerce_sub_category = "api/product/createProductSubCategory";
export const update_ecommerce_sub_category = "api/product/updateProductSubCategory";
export const delete_ecommerce_sub_category = "api/product/deleteProductSubCategory";
export const change_ecommerce_sub_category_status = "api/product/changeProductSubCategoryStatus";

export const get_ecommerce_attribute = "api/product/getAttributes";
export const create_ecommerce_attribute = "api/product/createAttribute";
export const update_ecommerce_attribute = "api/product/updateAttribute";
export const delete_ecommerce_attribute = "api/product/deleteAttribute";
export const change_ecommerce_attribute_status = "api/product/changeAttributeStatus";

export const get_ecommerce_product = "api/product/getProductsList";
export const create_ecommerce_product = "api/product/createProduct";
export const update_ecommerce_product = "api/product/updateProduct";
export const delete_ecommerce_product = "api/product/deleteProduct";
export const change_ecommerce_product_status = "api/product/changeProductStatus";

//! Static Page
export const get_about_us = 'api/admin/getAboutUs';
export const create_about_us = 'api/admin/createAboutUs';
export const get_terms_and_conditions = 'api/admin/getTermsAndCondition';
export const create_terms_and_conditions = 'api/admin/createTermsAndCondition';
export const get_privacy_policy = 'api/admin/getPrivacyPolicy';
export const create_privacy_policy = 'api/admin/createPrivacyPolicy';
export const get_refund_policy = 'api/admin/getRefundPolicy';
export const create_refund_policy = 'api/admin/createRefundPolicy';

//! Payment
export const get_payment_history = "api/payment/paymentHistory";

//! Testimonials
export const get_testimonials = "api/admin/getTestimonials";
export const create_testimonials = "api/admin/addTestimonials";
export const update_testimonials = "api/admin/updateTestimonials";
export const delete_testimonials = "api/admin/deleteTestimonialById";
export const change_testimonials_status = "api/admin/changeTestimonialStatus";

//! Transaction
export const get_transaction_history = (payload) => `api/admin/payment/get-user-payment-history?date=${payload?.date}&phone=${payload?.phone}&page=${payload?.page}&limit=${payload?.limit}&paymentkey=${payload?.paymentkey}`;

//! Operator Image
export const get_operator = "api/operator/get-operator-services-type";
export const get_operator_images = (operator) => `api/operator/get-operator-data?operatorType=${operator === undefined || operator == '' ? '' : operator?.name}`;
export const create_operator_images = "api/operator/create-operator";
export const update_operator_images = "api/operator/update-operator";

//! Flight Image
export const get_flight_images = "api/admin/payment/get-fligh-airline-images";
export const create_flight_images = "api/admin/payment/add-flight-airline-image";
export const update_flight_images = "api/admin/payment/update-fligh-airline-image";

//! Consultant requests
export const all_consultant_requests =  "api/admin/all_consultant_requests";
//! Astrologer
export const get_astrologer = "api/astrologer/get-all-astrologers";
export const get_astrologer_by_id = "api/astrologer/get-astrologer-details";
export const create_astrologer = "api/admin/add_astrologer";
export const update_astrologer_by_id = "api/astrologer/update-astrologer-details";
export const delete_astrologer_by_id = "api/admin/delete_astrologer";
export const verify_astrologer_profile = "api/astrologer/verify-astrologer-profile";
export const change_astrologer_chat_status = "api/astrologer/change-chat-status";
export const change_astrologer_call_status = "api/astrologer/change-call-status";
export const change_astrologer_video_call_status = "api/astrologer/change-video-call-status";

//! Astrologer Enquiry
export const get_enquiry_astrologer = "api/astrologer/get-enquired-astrologer";

//! Astrologer History
export const get_chat_history_by_astrologer_id = "api/astrologer/astrologers-chat-history";
export const get_call_history_by_astrologer_id = "api/astrologer/astrologer-call-history";
export const get_video_call_history_by_astrologer_id = "api/astrologer/get_astrologer_videocalls";
export const get_live_history_by_astrologer_id = "api/astrologer/get_astrolgoer_live_calls";
export const get_gift_history_by_astrologer_id = "api/admin/get_gift_history_by_astrologer";
export const get_review_by_astrologer_id = "api/admin/get_review_by_astrologer";
export const get_transaction_history_by_astrologer_id = "api/astrologer/astrologer_wallet_history";
export const get_puja_history_by_astrologer_id = "api/e-commerce/get_astrologer_puja_history";
export const update_wallet_by_astrologer_id = "api/admin/update_astrologer_wallet";

//! Withdrawal
export const get_withdrawal_requests = "api/admin/get_withdrawal_requests";
export const update_withdrawal_status = "api/admin/update_withdrawal_status";

//! Role Management
export const get_roles = "api/admin/getRoles";
export const create_role = "api/admin/createRole";
export const update_role = (id) => `api/admin/updateRole/${id}`;
export const delete_role = (id) => `api/admin/deleteRole/${id}`;
export const get_modules = "api/admin/getModules";

//! Activity Logs
export const get_activity_logs = "api/admin/getActivityLogs";
export const get_subadmin_logs = (userId) => `api/admin/getSubAdminLogs/${userId}`;

//! Enhanced SubAdmin with Roles
export const create_sub_admin_with_role = "api/admin/addSubAdminWithRole";
export const update_sub_admin_with_role = "api/admin/updateSubAdminWithRole";
export const get_sub_admins_with_roles = "api/admin/getAllSubadminsWithRoles";

//! Issue Control
export const issue_control_create = "api/admin/issue-control/create";
export const issue_control_all = "api/admin/issue-control/all";
export const issue_control_active = "api/admin/issue-control/active";
export const issue_control_stats = "api/admin/issue-control/stats";
export const issue_control_by_id = (id) => `api/admin/issue-control/${id}`;
export const issue_control_change_status = (id) => `api/admin/issue-control/${id}/status`;
export const issue_control_add_comment = (id) => `api/admin/issue-control/${id}/comment`;
export const issue_control_upload = "api/admin/issue-control/upload-attachment";
